module.exports = __webpack_public_path__ + "img/downloadApp26.cc500498.svg";